import React from 'react';
import { Formik } from 'formik';
import classNames from 'classnames';
import { FiAlertCircle } from 'react-icons/fi';

import LFModal from 'components/common/LFModal';
import Loading from 'components/common/loading/Loading';

import { rejectChangeRequestSchema } from 'schemas/changeIssuerSchema';

import type { RejectChangeRequest } from 'interface/issuer';

interface Props {
  isOpen: boolean;
  isRejectingRequest: boolean;
  onClose: () => void;
  onSubmit: (values: RejectChangeRequest) => void | Promise<void>;
}

function ChangeLeaveIssuerRejectModal({ isOpen, isRejectingRequest, onClose, onSubmit }: Props) {
  return (
    <LFModal
      customBtnClass="hide-d-none"
      stopPropagation={true}
      modalStatusIcon={<FiAlertCircle color="#F44336" size={24} />}
      className="leave-issuer-reject-modal"
      title={{
        text: 'Do you want to reject this request?',
        type: 'danger',
      }}
      message={{
        text: 'This action cannot be reverted back once rejected. Please write the reason for the rejection.',
        type: 'lf-modal__message',
      }}
      isOpen={isOpen}
      htmlContent={
        <Formik<RejectChangeRequest>
          validationSchema={rejectChangeRequestSchema}
          onSubmit={onSubmit}
          initialValues={{ rejectionReason: '' }}
        >
          {(formikProps) => {
            const { handleChange, handleSubmit, errors, values, handleBlur } = formikProps;

            return (
              <form onSubmit={handleSubmit} className="holiday-form">
                <div>
                  <label className="form-label grey--text">
                    Reason for rejection<span className="required ml-5">*</span>
                  </label>
                  <textarea
                    name="rejectionReason"
                    value={values.rejectionReason}
                    placeholder="Write a reason for rejecting the request..."
                    className={classNames('form-elem form-elem--input-sm', {
                      'form-elem--error': errors.rejectionReason,
                    })}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  ></textarea>
                  {errors.rejectionReason && <div className="error-block">{errors.rejectionReason}</div>}
                </div>

                <div className="ptpx-20">
                  <button
                    type="submit"
                    className="btn btn--large btn--red mrpx-14 delete__btn"
                    disabled={isRejectingRequest}
                  >
                    <span className={classNames({ invisible: isRejectingRequest })}>Yes, reject</span>
                    {isRejectingRequest && <Loading className="p-absolute white spinner-small" />}
                  </button>

                  <button
                    type="button"
                    className="btn btn--large btn--outlined-grey py-8 px-12"
                    onClick={onClose}
                    disabled={isRejectingRequest}
                  >
                    No, go back
                  </button>
                </div>
              </form>
            );
          }}
        </Formik>
      }
    />
  );
}

export default ChangeLeaveIssuerRejectModal;
